import {CustomerContactPerson} from './CustomerContactPerson';
import {CustomerAddress} from './CustomerAddress';

export enum ProductType {
    product = 'product',
    wrap = 'wrap',
    group = 'group'
}



// WEBPACK FOOTER //
// /app/src/model/Entities/ProductType.ts